import React, { useEffect, useState } from "react";
import "../../assets/css/home.css";

import HeroSection from "../../Components/HeroSection";
import Portfolio from "../../Components/Portfolio";
import AboutSection from "../../Components/AboutSection";
import Faqs from "../../Components/Faqs";
import CtaSection from "../../Components/CtaSection";
import OurServices from "../../Components/OurService";
import OurServices1 from "../../Components/OurServices1";



const HomeIndex = () => {
 
  const [isMobile, setIsMobile] = useState(window.innerWidth < 760 )

  useEffect(()=> {
    const handleResize = () =>{
      setIsMobile(window.innerWidth < 760)
      // console.log("window size", isMobile)
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize)
  },[]
  )

  return (
    <>
     
      <HeroSection />
      <OurServices />
   
      {/* <ServicesSection /> */}
      <OurServices1 />
      <Portfolio />
      {/* <Testimonials /> */}
      <AboutSection />
      <Faqs />
      <CtaSection />
    </>
  );
};

export default HomeIndex;
